module.exports = {
  ChartingColors: {
    Sequential: [
      "#B796FF",
      "#CBB2FF",
      "#DBCCFF",
      "#92E2EA",
      "#BAEDF2",
      "#D1F3F7",
      "#BBBCC8",
      "#C9CAD3",
    ],
    Categorical: [
      "#AA85FF",
      "#631FFF",
      "#92E2EA",
      "#2CBCC9",
      "#8FDBAB",
      "#35A260",
      "#FFA26F",
      "#F9682A",
      "#FFDC81",
      "#EBAC00",
      "#FDA0B8",
      "#FC5A85",
      "#81AEFF",
      "#2379FA",
    ],
  },
};
